import React from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Headers from './Components/headers/headers';
import Main from './Views/main/main';
import JusticePage from './Views/decision/decision';
import Detaildecision from './Views/decision/decision';
import DecisionResult from './Views/Result/Decisionresult/Decisionresults';
import AllLoiResults from './Views/Result/TextDeLoisresult/loiesresult';
import DetailLois from './Views/textdelois/textdelois';

function App() {
  return (
    <Router>
      {/* <Headers /> */}
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/allresult" element={<DecisionResult />} />
        <Route path="/Loisresult" element={<AllLoiResults />} />
        <Route path="/article/:id" element={<DetailLois />} />
        <Route path="/decision/:id" element={<Detaildecision />} />
      </Routes>
    </Router>
  );
}

export default App;


// import React from 'react';
// import './App.css';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import Headers from './Components/headers/headers';
// import Main from './Views/main/main';
// import JusticePage from './Views/decision/decision';
// import Detaildecision from './Views/decision/decision';
// import LoginView from './Views/Authentification/LoginView';
// import ForgetPasswordView from './Views/Authentification/ForgetPasswordView';
// import ResetPassword from './Views/Authentification/ResetPassword';

// function App() {
//   return (
//     <Router>
//       {/* <Headers /> */}
//       <Routes>
//         <Route index element={<LoginView />} />
//         <Route path="mot-de-passe-oublie" element={<ForgetPasswordView />} />
//         <Route path="password-reset-confirm/:uid/:token/" element={<ResetPassword />} />
//         <Route path="*" element={<Main />} />
//         <Route path="/decision/:id" element={<Detaildecision />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;

